import axios from 'axios';

const ENV_PATH = '/env.json';

interface IGMTData {
  id: string;
  gtm_auth: string;
  gtm_preview: string;
}

class GAService {
  static staticUrl(url: string): string {
    const pathname = window.location.origin;
    const pathnameWithoutSlash = pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname;
    return pathnameWithoutSlash + url;
  }

  static initGA(w: any, d: any, s: string, l: string, data: IGMTData) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    let auth = '';
    if (data.gtm_auth) {
      auth = `&gtm_auth=${data.gtm_auth}&gtm_preview=${data.gtm_preview}&gtm_cookies_win=x`;
    }
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${data.id}${dl}${auth}`;
    f.parentNode.insertBefore(j, f);
  }

  static fetchEnv() {
    return axios.get(GAService.staticUrl(ENV_PATH)).then(resp => resp.data);
  }
}

export default GAService;
